import { Avatar, HStack, Heading, Stack, VStack } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { useEffect, useState } from "react";
import { getContact } from "../api/contact";
import { getFooter } from "../api/footer";
import Loading from "../components/Layout/Loading";

const textForWA = "Hallo, Saya ingin bertanya mengenai I Fit Sport Indonesia";

export default function Main() {
    const [showNumber, setShowNumber] = useState(false);
    const [load, setLoad] = useState(true);
    const [contact, setContact] = useState([]);
    const [footer, setFooter] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [contactRes, footerRes] = await Promise.all([getContact(), getFooter()]);
                setContact(contactRes);
                setFooter(footerRes);
            } catch (error) {
                console.error("Error fetching data:", error);
                // Optionally set error state here
            } finally {
                setLoad(false);
            }
        };

        fetchData();
    }, []);

    if (load) {
        return <Loading />
    }

    return (
        <Stack
            gap="0px"
            w="100%"
            bgColor="gray.900"
            color="white"
            pos="relative"
        >
            <Header />

            <Outlet />

            <Footer contact={contact} footer={footer} />
            <a
                href={`https://wa.me/${footer[3].value}?text=${textForWA
                    .split(" ")
                    .join("%20")}`}
                target="blank"
            >
                <VStack
                    _hover={{
                        opacity: 1,
                    }}
                    onMouseEnter={() => setShowNumber(true)}
                    onMouseLeave={() => setShowNumber(false)}
                    zIndex={10}
                    opacity="0.7"
                    pos="fixed"
                    bottom={8}
                    right={8}
                    transition="opacity .3s"
                >
                    <HStack
                        justifyContent="space-between"
                        px={1}
                        py={1}
                        w="100%"
                        rounded="full"
                        bgColor="pink"
                    >
                        <Heading ps={2} fontSize={{ base: "md", lg: "lg" }}>
                            {!showNumber ? "Contact Us" : footer[3].value.replace(/^62/, "0").replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3")}
                        </Heading>
                        <Avatar w={8} h={8} src="/icon/whatsapp.png" />
                    </HStack>
                </VStack>
            </a>
        </Stack>
    );
}
